export { default as CheckboxButton } from './CheckboxButton'


// WEBPACK FOOTER //
// ./src/components/inputs/CheckboxButton/index.js